import ApiService from '@/helpers/api.service';
import ApiService2 from '@/helpers/api.service.ext';

const API = new ApiService();
const API2 = new ApiService2();

// Endpoints

export const state = {
    topupLogs: [],
    topupLogsPageInfo: {
        total: 0
    },
    eloadLogs: [],
    eloadLogsPageInfo: {
        total: 0
    },
    eloadStatus: {},
    blvckTopupLogs: [],
    blvckTopupLogsPageInfo: {
        total: 0
    },
    errors: null
}

export const mutations = {
    UPDATE_TOPUP_LOGS(state, list){
        state.topupLogs = list;
    },
    UPDATE_TOPUP_LOGS_PAGE_INFO(state, total){
        state.topupLogsPageInfo.total = total;
    },
    UPDATE_ELOAD_LOGS(state, list){
        state.eloadLogs = list;
    },
    
    UPDATE_ELOAD_LOGS_PAGE_INFO(state, total){
        state.eloadLogsPageInfo.total = total;
    },
    UPDATE_ELOAD_STATUS(state, data){
        state.eloadStatus = data;
    },
    SET_PROD_ERRORS(state, errors){
        state.errors = errors;
    },
    UPDATE_BLVCK_TOPUP_LOGS(state, list){
        state.blvckTopupLogs = list;
    },
    UPDATE_BLVCK_TOPUP_LOGS_PAGE_INFO(state, total){
        state.blvckTopupLogsPageInfo.total = total;
    }
}

export const actions = {

    fetchPaymongoTransaction(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/topup/transactions`, params)
            .then((response) => {
                resolve(response.data.message.rows);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    getTopupLogs(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/topup/list`, params)
            .then(({ data }) => {
              context.commit('UPDATE_TOPUP_LOGS', data.message.rows);
              context.commit('UPDATE_TOPUP_LOGS_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    exportTopupLogs(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/topup/export`, params)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    getEloadLogs(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/reports/eload/list`, params)
            .then(({ data }) => {
              context.commit('UPDATE_ELOAD_LOGS', data.message.rows);
              context.commit('UPDATE_ELOAD_LOGS_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    getEloadTransactionDetails(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/reports/eload/info`, params)
            .then(({ data }) => {
              context.commit('UPDATE_ELOAD_LOGS', data.message.rows);
              context.commit('UPDATE_ELOAD_LOGS_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    updateEloadTransactionStatus(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`/reports/eload/update-status`, params)
            .then(({ data }) => {
                if (data.status === "ok") {
                    context.commit('UPDATE_ELOAD_STATUS', data.message);
                    resolve();
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    exportEloadLogs(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/reports/eload/export`, params)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    getBlvckTopupLogs(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/topup/blvck-list`, params)
            .then(({ data }) => {
              context.commit('UPDATE_BLVCK_TOPUP_LOGS', data.message.rows);
              context.commit('UPDATE_BLVCK_TOPUP_LOGS_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    testReward(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/eload-rewards/add-reward`, params)
            .then(({ data }) => {
                console.log(">> test reward:",JSON.stringify(data));
                resolve();
            })
            .catch(({ response }) => {
                console.log(">> err reward:",JSON.stringify(response));
                reject();
            });
        });
    },
}

export const getters = {
    
}